export const __COLORS = {
	white: "#ffffff",
	whiteSmoke: "#f5f5f5",
	ghostWhite: "#f8f9fe",

	black: "#000000",
	charcoal: "#222222",
	shadowGrey: "#444444",

	grey: "#666666",
	mediumGrey: "#9ea0a4",
	cloudGrey: "#cccccc",
	mistGrey: "#eaebec",
	softGrey: "b9b9b9",
	slateGrey: "#708090",

	royalBlue: "#3f51b5",
	midnightBlue: "#2c3e91",

	vividPurple: "#6f57e9",

	crimsonRed: "#e71919",
};
